import { AfterViewInit, Component, DoCheck, EventEmitter, inject, OnDestroy, OnInit, output, Output } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { APIUrlConstants } from '../../constants/api-url-constants';
import { ShellMessageService } from '../../services/message.service';

import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { EngagementService } from '../../../core/services/engagement/engagement.service';
import { UserService } from '../../../core/services/user/user.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    imports: [
        CommonModule,
        RouterModule
    ]
})
export class NavigationComponent implements OnInit, AfterViewInit, DoCheck, OnDestroy {
  private _engagementService = inject(EngagementService);
  public _userService = inject(UserService);
  private _sanitizer = inject(DomSanitizer);
  private _messageService = inject(ShellMessageService);
  router = inject(Router);

  showAssistantChange = output<boolean>();

  //@Output() emitShowAssistant = new EventEmitter<boolean>();
  @Output() emitLogout = new EventEmitter();

  isMenuActive: boolean = false;
  pageTitle: string = 'iManage Home';
  headerLink: string = '/home';
  headerIcon = '/assets/icons/home-3.png';
  headerIconStyles = 'vertical-align: top; display: inline;margin-top:2px;';
  headerIconWidth!: string;
  isRoot = false;
  currentUrl: string = '';
  currentEngagementId: string = '';
  isUtils = false;
  isMobile!: boolean;
  isAccountRequest!: boolean;
  isShellEdit!: boolean;
  isLinkExistingTeamsSite!: boolean;
  showAssistant!: boolean;
  contentheight!: number;
  showMenu!: boolean;
  menuSize!: number;

  destroyed = new Subject<void>();

  constructor() {
    inject(BreakpointObserver)
      .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
      .pipe(takeUntil(this.destroyed))
      .subscribe((result) => {
        if (result.breakpoints[Breakpoints.XSmall]) {
          this.isMobile = true;
        } else {
          this.showAssistant = true;
          this.isMobile = false;
        }
      });
  }

  ngOnInit(): void {
    this._engagementService.isMenuActivatedChange.subscribe((isMenuActive) => {
      this.isMenuActive = isMenuActive;
      if (isMenuActive === true) {
        this.currentEngagementId = this._engagementService.currentEngagementV2()?.id!;
      }
    });
  }

  ngAfterViewInit(): void {
    const nav = document.getElementById('nav');
    if (nav) {
      this.menuSize = nav.getClientRects()[0].height;
    }
  }

  ngDoCheck(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
        if (
          !this.currentUrl.endsWith('/') &&
          !this.currentUrl.endsWith('/home')
        ) {
          this.isShellEdit = false;
          this.isUtils = false;
          this.isRoot = false;
          this.isAccountRequest = false;
          this.isLinkExistingTeamsSite = false;
        } else {
          this.isShellEdit = false;
          this.isUtils = false;
          this.isRoot = true;
          this.isAccountRequest = false;
          this.isLinkExistingTeamsSite = false;
        }
        this.checkHeader();
        if (this.currentUrl.includes(APIUrlConstants.SHELL_LINKFILTER) ||
          this.currentUrl.includes(APIUrlConstants.SHELL_NEWACCOUNT) ||
          this.currentUrl.includes(APIUrlConstants.SHELL_ISSUEREPORT)
        ) {
          this.headerLink = APIUrlConstants.SHELL_FILTER;
          this.isUtils = true;

          // const headerContainer = document.getElementById('header-container');
          // if (!headerContainer) throw new Error('Header container not found');

          // if (headerContainer.clientHeight) {
          //   headerContainer.style.maxHeight = window.innerWidth > 720 ? '60px' : '200px';
          //   headerContainer.style.background = '#ccc';
          // }

          // const container = document.querySelector('.container') as HTMLElement;
          // if(!container) throw new Error('Container not found');
          // container.style.marginTop = `${headerContainer.offsetHeight - 60}px`;

          if (this.currentUrl.includes(APIUrlConstants.SHELL_NEWACCOUNT) ||
            this.currentUrl.includes(APIUrlConstants.SHELL_ISSUEREPORT)
          ) {
            this.isAccountRequest = true;
          }
        }
        if (
          (this.currentUrl.includes(APIUrlConstants.SHELL_EDIT) ||
            this.currentUrl.includes(APIUrlConstants.SHELL_ENGPERMISSION) ||
            this.currentUrl.includes(APIUrlConstants.SHELL_LINKFILTER) ||
            this.currentUrl.includes(APIUrlConstants.PKICCDR) ||
            this.currentUrl.includes(APIUrlConstants.PKICREQUESTFORM) ||
            this.currentUrl.includes(APIUrlConstants.LINKEXISITNG) ||
            this.currentUrl.includes(APIUrlConstants.ORDEROPPFORM) ||
            this.currentUrl.includes(APIUrlConstants.RESOURCEREQUEST) ||
            this.currentUrl.includes(APIUrlConstants.RESOURCEREQUESTNEW) ||
            this.currentUrl.includes(APIUrlConstants.LINKEXISITINGTEAMSSITE) ||
            this.currentUrl.includes(APIUrlConstants.SHELLSLINKEDTEAMSSITE) ||
            this.currentUrl.includes(APIUrlConstants.CLIENT_ACCEPTANCE + '/') ||
            this.currentUrl.includes(APIUrlConstants.CONTRACTS) ||
            this.currentUrl.includes(APIUrlConstants.RELATEDSHELLS)) 
        ) {
          this.headerLink = APIUrlConstants.SHELL_FILTER;
          this.isShellEdit = true;
          this.isLinkExistingTeamsSite = this.currentUrl.includes(
            APIUrlConstants.LINKEXISITINGTEAMSSITE,
          );
        }
      }
    });
    this.currentUrl = window.location.href;
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  checkHeader(): void {
    if (this.currentUrl.includes(APIUrlConstants.SHELL_FILTER)) {
      this.pageTitle = 'iManage Shell Filter List';
      this.headerLink = '/engagements/shellFilter'; // Set the correct route for iManage Shell Filter List
    } else if (
      this.currentUrl.endsWith('/') ||
      this.currentUrl.endsWith('/home')
    ) {
      this.pageTitle = 'iManage Home';
      this.headerLink = '/home'; // Route for home
    } else if (
      this.currentUrl.includes(APIUrlConstants.CONTRACTS) ||
      this.currentUrl.includes(APIUrlConstants.RELATEDSHELLS)
    ) {
      this.pageTitle = 'Contracts';
      this.headerLink = '/contracts'; // Set the correct route for Contracts
    } else {
      this.pageTitle = 'iManage';
      this.headerLink = '/home'; // Default route
    }
    this.setHeaderIcon();
  }

  setHeaderIcon(): void {
    if (this.isRoot) {
      this.headerIcon = '/assets/icons/home-3.png';
      this.headerIconStyles =
        'vertical-align: top; display: inline;margin-top:2px;';
      this.headerIconWidth = '40';
    } else if (!this.isRoot) {
      this.headerIcon = '/assets/icons/handshake-white-orange.png';
      this.headerIconStyles =
        'vertical-align: top; display: inline;margin-top:8px;';
      this.headerIconWidth = '50';
    }
    if (this.isMobile) {
      this.headerIconWidth = '50';
      this.headerIconStyles =
        'vertical-align: top; display: inline;margin-top:.25em;';
    }

    if (
      this.currentUrl.includes(APIUrlConstants.CONTRACTS) ||
      this.currentUrl.includes(APIUrlConstants.RELATEDSHELLS)
    ) {
      this.headerIcon = '/assets/icons/contracts-white.png';
      this.headerIconStyles =
        'vertical-align: top; display: inline;margin-top:2px;';
      this.headerIconWidth = '40';
    }
  }

  showAssistantMenu(): void {
    this.showMenu = !this.showMenu;
    if (this.showMenu) {
      this._messageService.sendDropDownHideSubject();
      this.showMenu = true;
      this.showAssistantChange.emit(true);
    } else {
      this.showAssistantChange.emit(false);
    }
  }

  logout(): void {
    this.emitLogout.emit();
  }
}
